import { FastMCP } from "fastmcp"

export const server = new FastMCP({
  name: "patents-mcp-server",
  version: "1.0.0",
})
